//import * as React from 'react';
import React, { useRef } from 'react';
import { fetchConToken } from 'helpers/fetch';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

function sleep(duration) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, duration);
    });
}

export default function AsyncSelectTextField(props) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [valueTextField, setValueTextField] = React.useState();
    const [valueSelectTo, setValueSelectTo] = React.useState();
    const [keyDownEnter, setKeyDownEnter] = React.useState();
    const valueTextFieldRef = useRef(valueTextField);

    const handleClose = () => {
        setOpen(false);
        setValueTextField('');
        setOptions([]);
    };

    const onChangeSelectTo = (event, newValue) => {
        setValueSelectTo(newValue);
        if (props.setValueSelectTo) props.setValueSelectTo(newValue);

        if (props.onChangeSelectTo) props.onChangeSelectTo(newValue);
    }

    const onChangeTextField = (e) => {
        setValueTextField(e.target.value);
        if (e.target.value === '') handleClose();
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') setKeyDownEnter(!keyDownEnter);
    }

    React.useEffect(() => {
        if (valueTextFieldRef.current === '') return;

        const handleOpen = () => {
            if (valueTextFieldRef.current === '') return;

            setOpen(true);
            (async () => {
                setLoading(true);
                await sleep(1e3);
                setLoading(false);

                fetchConToken(`${props.url}&busqueda=${valueTextFieldRef.current}`).then(res => {
                    console.log((props.resIsTableMode) ? res?.data : res);
                    setOptions((props.resIsTableMode) ? res?.data : res);
                });
            })();
        };
        handleOpen();
    }, [keyDownEnter, props.resIsTableMode, props.url]);

    React.useEffect(() => handleClose(), []);

    React.useEffect(() => { if (valueTextFieldRef) valueTextFieldRef.current = valueTextField; }, [valueTextField]);

    return (<Autocomplete
        open={open}
        autoHighlight
        options={options}
        loading={loading}
        onClose={handleClose}
        inputValue={valueSelectTo}
        onChange={onChangeSelectTo}
        isDisabled={props.disabled}
        disablePortal={props.disablePortal}
        getOptionLabel={props.getOptionLabel}
        getOptionValue={props.getOptionValue}
        disableClearable={props.disableClearable}
        renderInput={(params) => (<TextField
            {...params}
            label={props.label}
            value={valueTextField}
            onChange={onChangeTextField}
            onKeyDown={onKeyDown}
            slotProps={{
                input: {
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                },
            }}
        />)}
    />);
}